var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.25C3.92894 5.25 2.25 6.92894 2.25 9C2.25 11.0711 3.92894 12.75 6 12.75H12C14.071 12.75 15.75 11.0711 15.75 9C15.75 6.92894 14.071 5.25 12 5.25H6ZM6 3.75H12C14.8995 3.75 17.25 6.10051 17.25 9C17.25 11.8995 14.8995 14.25 12 14.25H6C3.10051 14.25 0.75 11.8995 0.75 9C0.75 6.10051 3.10051 3.75 6 3.75ZM6 11.25C4.75736 11.25 3.75 10.2427 3.75 9C3.75 7.75733 4.75736 6.75 6 6.75C7.24264 6.75 8.25 7.75733 8.25 9C8.25 10.2427 7.24264 11.25 6 11.25Z",
    fill: "#8080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleLine);
export default __webpack_public_path__ + "static/media/toggle-line.5e0ee57494d1a87977cd7ad7d2f3ce8f.svg";
export { ForwardRef as ReactComponent };